<div class="fx-row-start-center">
  <div>
   <a class="navlink" routerLink="/apps">EOLA : Enterprise View : </a>
  </div>
  <div>
   <a class="navlink" routerLink="/plantView/{{plant}}/{{plantDisplay}}">{{plantDisplay}}</a>
  </div>
  <div>
    <a class="navlink">: {{lineDisplay}} : {{severityInfo}}</a>
  </div>
</div> 

<div class="flex-column">
  <div class="fx-row-space-evenly-center" id="options">
    <div class="date-row">
      <app-date-selection (dateChange)="onDateChange($event)"></app-date-selection>
    </div>
  
    <button (click)="loadAllRecords()" mat-raised-button color="primary" class="saveToButton">Save to csv</button>
    <a routerLink="/charts/trendChart/{{plant}}/{{line}}">
      <button
      mat-raised-button
      color ="primary"
      >
        Trend Chart
      </button> 
    </a>
    <button mat-raised-button color="primary" (click)="navToAnalysis()">Analysis</button>
    <button mat-raised-button color="primary" (click)="navToShopFloor()">Shop Floor Top Three</button>
  </div>

  <div class="filters">

    <mat-form-field>
      <input matInput [(ngModel)]="filterValues.model" (input)="applyFilter()" placeholder="Search Model">
    </mat-form-field>

    <mat-form-field>
      <input matInput [(ngModel)]="filterValues.serial" (input)="applyFilter()" placeholder="Search Serial">
    </mat-form-field>
    <mat-form-field>
      <mat-select panelClass="auto-width-dropdown" [(ngModel)]="filterValues.shift" (selectionChange)="applyFilter()">
        <mat-option value="">All Shifts</mat-option>
        <mat-option *ngFor="let s of uniqueShifts" [value]="s">
          {{s}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-select  panelClass="auto-width-dropdown" [(ngModel)]="filterValues.area" (selectionChange)="applyFilter()">
        <mat-option value="">All Areas</mat-option>
        <mat-option *ngFor="let a of uniqueAreas" [value]="a">{{a}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-select  panelClass="auto-width-dropdown" [(ngModel)]="filterValues.component" (selectionChange)="applyFilter()">
        <mat-option value="">All Components</mat-option>
        <mat-option *ngFor="let c of uniqueComponents" [value]="c">{{c}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-select panelClass="auto-width-dropdown" [(ngModel)]="filterValues.defect" (selectionChange)="applyFilter()">
        <mat-option value="">All Defects</mat-option>
        <mat-option *ngFor="let d of uniqueDefects" [value]="d">{{d}}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-select panelClass="auto-width-dropdown" [(ngModel)]="filterValues.severity" (selectionChange)="applyFilter()">
        <mat-option value="">All Severity Types</mat-option>
        <mat-option value="MINOR">Minor</mat-option>
        <mat-option value="MAJOR">Major</mat-option>
        <mat-option value="CRITICAL">Critical</mat-option>
      </mat-select>
    </mat-form-field>

    <button mat-raised-button color="primary" (click)="resetFilters()">
      Reset
    </button>

  </div>

    <div class="fx-column-center-center">
      <div class="mat-elevation-z8 table-container" id="plantTable">
        <table mat-table  class="full-width-table" [dataSource]="dataSource" matSort aria-label="Elements">

           <!-- Result Date Time Column -->
           <ng-container matColumnDef="ResultDateTime" >
            <th mat-header-cell *matHeaderCellDef mat-sort-header >Result Date Time</th>
            <td mat-cell *matCellDef="let row">{{row.ResultDateTime | date:'medium' }}</td>
          </ng-container>

           <!-- Shift Column -->
           <ng-container matColumnDef="Shift">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Shift</th>
            <td mat-cell *matCellDef="let row">{{row.Shift}}</td>
          </ng-container>

          <!-- Line Column -->
          <ng-container matColumnDef="Line">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Line</th>
            <td mat-cell *matCellDef="let row">{{row.Line}}</td>
          </ng-container>

          <!-- Model Column -->
          <ng-container matColumnDef="Model">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Model</th>
            <td mat-cell *matCellDef="let row">{{row.Model}}</td>
          </ng-container>

          <!-- Serial Column -->
          <ng-container matColumnDef="Serial">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Serial</th>
            <td mat-cell *matCellDef="let row">{{row.Serial}}</td>
          </ng-container>

          <!-- Audit Type -->
          <ng-container matColumnDef="AuditType">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Audit Type</th>
            <td mat-cell *matCellDef="let row">{{row.AuditType}}</td>
          </ng-container>

          <!-- Severity Column -->
          <ng-container matColumnDef="Severity">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Severity</th>
            <td mat-cell *matCellDef="let row">{{row.Severity}}</td>
          </ng-container>
  
          <!-- Acknowledge Column -->
          <ng-container matColumnDef="Acknowledge">
            <th mat-header-cell *matHeaderCellDef>Acknowledge</th>
            <td mat-cell *matCellDef="let row ; let i = index">
            <span *ngIf = "row.Severity == 'CRITICAL' || row.Severity == 'MAJOR'">
              <button mat-button color="success"  *ngIf = "row.Acknowledgeresultid != null" (click)="displayAcknowledge(row)" ><mat-icon>verified_user</mat-icon>View</button>
              <button mat-button color="needsreview"  *ngIf = "row.Acknowledgeresultid == null" (click)="displayAcknowledge(row)" ><mat-icon>done</mat-icon>Acknowledge</button>
            </span>
          </td>
          </ng-container>  
  
          <!-- Area Description Column -->
          <ng-container matColumnDef="AreaDescription">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Area Description</th>
              <td mat-cell *matCellDef="let row">{{row.AreaDescription}}</td>
            </ng-container>

            <!-- Component Description Column -->
          <ng-container matColumnDef="ComponentDescription">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Component Description</th>
              <td mat-cell *matCellDef="let row">{{row.ComponentDescription}}</td>
            </ng-container>

            <!-- Defect Description Column -->
          <ng-container matColumnDef="DefectDescription">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Defect Description</th>
              <td mat-cell *matCellDef="let row">{{row.DefectDescription}}</td>
            </ng-container>

          <!-- Operator Name Column -->
          <ng-container matColumnDef="OperatorName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Operator Name</th>
            <td mat-cell *matCellDef="let row">{{row.OperatorName}}</td>
          </ng-container>

          <!-- Note Column -->
          <ng-container matColumnDef="Notes">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Notes</th>
            <td mat-cell *matCellDef="let row">{{row.Note}}</td>
          </ng-container>
          
          <ng-container matColumnDef="Details">
            <th mat-header-cell *matHeaderCellDef>Details</th>
            <td mat-cell *matCellDef="let row">
              <button mat-button color="primary" *ngIf = "row.DetailsExist || row.Image1 || row.Image2" (click)="displayDetails(row)"><mat-icon>list</mat-icon>Details</button>
            </td>
          </ng-container>  


  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row matRipple *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
    
    <div class="pagination" *ngIf="hasMore || currentOffset > 0">
      <button *ngIf="hasMore || currentOffset > 0" (click)="prevPage()" [disabled]="isLoading || currentOffset === 0">Previous</button>
      <span *ngIf="hasMore || currentOffset > 0">Page {{ currentPage }}</span>
      <button [disabled]="isLoading || !hasMore" (click)="nextPage()" >Next</button>
    </div> 
  </div>
  